import { CalendarTimezoneData } from "@/common/types/calendarTimezone.type";
import { formatDateWithTimezone } from '@/common/utils/formatters';
import { useId } from "react";
import { Tooltip } from "react-tooltip";

interface BillDateTitleWithTimezoneProps {
  startDate?: string;
  endDate?: string;
  timezone?: CalendarTimezoneData;
}

const BillDateTitleWithTimezone = ({
  startDate,
  endDate,
  timezone,
}: BillDateTitleWithTimezoneProps) => {
  const uniqueId = useId();

  const ianaTimeZone = timezone?.identifier || 'America/Sao_Paulo';

  const userTimezoneIdentifier = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const startDateInClientTimezone = startDate ? formatDateWithTimezone(new Date(startDate), ianaTimeZone) : '';
  const endDateInClientTimezone = endDate ? formatDateWithTimezone(new Date(endDate), ianaTimeZone) : '';

  const startDateInUserTimezone = startDate ? formatDateWithTimezone(new Date(startDate), userTimezoneIdentifier) : '';
  const endDateInUserTimezone = endDate ? formatDateWithTimezone(new Date(endDate), userTimezoneIdentifier) : '';

  const userTimezoneFormatted = userTimezoneIdentifier.replace(/\//g, ' - ').replace(/_/g, ' ');

  return (
    <>
      <p data-tooltip-id={uniqueId} className="cursor-default">
        {[startDateInClientTimezone, endDateInClientTimezone].join(' - ')}

        <span className="italic font-light ms-1">
          ({timezone ? (timezone?.display_name || timezone.identifier) : 'América - São Paulo'})
        </span>
      </p>

      <Tooltip id={uniqueId} className="z-50">
        <p>
          {[startDateInUserTimezone, endDateInUserTimezone].join(' - ')}

          <span className="italic font-light ms-1">({userTimezoneFormatted})</span>
        </p>
      </Tooltip>
    </>
  );
};

export default BillDateTitleWithTimezone;
